import { Component, Injector, OnInit, HostListener } from '@angular/core';
import { Geolocation } from '@capacitor/geolocation'; // new package used here
import { AlertService } from 'src/app/shared/services/alert.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { Platform, NavParams, ModalController } from '@ionic/angular';
import { ILocation, LocationService } from 'src/app/services/location.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { DateHelpers } from 'src/app/shared/helpers/date.helpers';
import { GeolocationHelpers } from 'src/app/helpers/geolocataion-helpers';
import { ActivatedRoute,Router } from '@angular/router';
import {GlobalPayments} from "src/assets/globalpayments-3ds.js";
import { HttpHelpers } from 'src/app/shared/helpers/http.helpers';
import { PaymentService } from 'src/app/account/services/payment.service';
//import { CreditCard } from 'angular-cc-library'; // replaced
//import { CreditCardDirectivesModule } from 'ngx-credit-cards';
import { AuthService } from 'src/app/auth/services/auth.service';
import { NotificationServiceService, INotifications } from 'src/app/store/services/notification-service.service';
import { NotificationBellServiceService } from 'src/app/store/services/notification-bell-service.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { IconService } from 'src/app/shared/services/icon.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
//import { checkVersion, initiateAuthentication } from "src/assets/globalpayments-3ds.js";

//import { ChallengeWindowSize, MethodUrlCompletion, checkVersion, getBrowserData, handleMethodNotification, initiateAuthentication } from 'globalpayments-3ds'
//import { NEVER } from 'rxjs';
declare var google: any;

export interface IGeoposition {
  latitude: number;
  longitude: number;
}

@Component({
    selector: 'app-locations-page',
    templateUrl: './locations-page.component.html',
    styleUrls: ['./locations-page.component.scss'],
    standalone: false
})
export class LocationsPageComponent implements OnInit {
  title: string = 'Nav.Locations';
  alttitle: string = 'Nav.LocationsAlt';

  locations: ILocation[];
  displayedLocations: ILocation[] = [];
  currentSegment: string = 'list';

  position: IGeoposition;

  searchText: string = '';
  searchMapCenter: IGeoposition | null = null;

  valideNotification: number;
  AllNotifications: INotifications[];

  disableHeader: boolean = false;
  isPopup: boolean = false;
  mobile: boolean = false;

  bellIcon: IconDefinition;

  showGeoLocation: boolean = false;
  hasPosition: boolean = false;

  homersLayout: boolean = false;

  public searchSubject = new Subject<string>();

  

  getCurrentPath(): string {
    return this.router.url;
  }

  constructor(private alert: AlertService,
    //private geolocation: Geolocation,
    public setting: SettingService,
    private platform: Platform,
    private loader: LoaderService,
    private locationService: LocationService,
    //public translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private paymentService: PaymentService,
    public auth: AuthService,
    public NotificationService: NotificationServiceService,
    public NotificationBellService: NotificationBellServiceService,
    private injector: Injector,
    private modalCtrl: ModalController,
    private analytics: AnalyticsService,
    private iconService: IconService,
    private translationService: TranslationService
  ) { 
    this.bellIcon = this.iconService.getIcon('bell')!;
  }

 

  async ngOnInit() {
    // Only access NavParams if running inside a modal
    const navParams = this.injector.get(NavParams, null);

    
    try {
      if(navParams.get('disableHeader') != undefined) {
        this.disableHeader = navParams.get('disableHeader');
        this.isPopup = true;
      }
    } catch (e) {

    }

    if(!this.isPopup) {
      var currentUrl = this.getCurrentPath();
      localStorage.setItem('Stateurl', currentUrl);
    } else {
      localStorage.setItem('Stateurl', 'popup-locations');
    }

    this.analytics.UpdateLocation({url: "/locations", ispopup: this.isPopup},  true, false);
    

    try {
      this.valideNotification = await this.NotificationService.notificationCount();
      this.AllNotifications = this.NotificationService.notifationArray;
    } catch (e) {
      console.log("error collecting Notification Data");
    }

  //  try {
  //   var versionCheckData: any = await GlobalPayments.ThreeDSecure.checkVersion('http://legacy-api.com:9001/GlobalThreeDS/CheckVersion', {
  //     card: {
  //        number: "4263970000005262"
  //     },
  //     terminal : "20538",
  //     subdomain: HttpHelpers.getSubdomain()
  //  });
      
    
  //  if (versionCheckData.error) {
  //     // TODO: handle the scenario where the card is not enrolled for 3D Secure 2
  //     return;
  //  }

  //  var authenticationData:any = await GlobalPayments.ThreeDSecure.initiateAuthentication('http://legacy-api.com:9001/GlobalThreeDS/ThreeDSecureInitiateAuth', {
  //      serverTransactionId: versionCheckData.serverTransactionId,
  //      methodUrlComplete: true,
  //      card: {
  //         expiryMonth: "03",
  //         expiryYear: "2025",
  //         securityCode: "123",         
  //         cardHolderName: "Francis Plouffe",
  //        // number:  "4263970000005262",//no challenge
  //        number: "4012001038488884" //challenge

  //      },       
  //      challengeWindow: {
  //         windowSize: GlobalPayments.ThreeDSecure.ChallengeWindowSize.Windowed500x600,
  //         displayMode: 'lightbox',
  //      },
  //      browserData: GlobalPayments.ThreeDSecure.getBrowserData(),
  //      terminal : "t4tGHXF/s9X0GFeIH3SC/QgKMG99t1FaI8mqgsN7EGc=",
  //      billingAddress: {
  //       streetAddress1 : "314 avenue barron",
  //       city : "Lachute",
  //       postalCode : "J8H0N3",
  //       state : "QC",
  //       country : "CA"
  //      },
  //      amount: 250,
  //      email: "fplouffe@seemyapps.com",
  //      phone: "14505128078"     

  //      // order: {}, // optional if data available on client-side
  //      // payer: {}, // optional if data available on client-side
  //   });

  //   debugger;

  //   // frictionless authentication success and authorization success
  //   if (authenticationData.result == "AUTHORIZATION_SUCCESS") {
  //      // TODO: proceed to success page or display success information
  //   }

  //   // frictionless authentication success and authorization failure
  //   else if (authenticationData.result == "AUTHORIZATION_FAILURE") {
  //      // TODO: proceed to failure page or display decline information
  //   }

  //   // frictionless authentication failure
  //   else if (authenticationData.result == "AUTHENTICATION_FAILURE") {
  //      // TODO: proceed to failure page or display failed authentication information
  //   }

  //   else if (authenticationData.challenge.response.data.transStatus == "Y") {
  //     document.querySelectorAll('.hide-global-logo').forEach(e => e.remove());
  //     var serverTransactionId = authenticationData.challenge.response.data.threeDSServerTransID;
  //     //do a test to trigger the final authorization from global
  //      await this.paymentService.authorize3DS({
  //       amount: 250,
  //       card: {
  //         expiryMonth: "03",
  //         expiryYear: "2025",
  //         securityCode: "123",         
  //         cardHolderName: "Francis Plouffe",
  //         type: CreditCard.cardType("4012001038488884"),
  //        // number:  "4263970000005262",//no challenge
  //        number: "4012001038488884" //challenge  
  //      },
  //      terminal: "20538",
  //      serverTransactionId: serverTransactionId 
  //      }).subscribe(success => {
  //       debugger;
  //       var t = "";
  //      });

  //     //var form = document.getElementById("myForm");
  //    // form.setAttribute("action", "/ThreeDSecure2/Authorization");

  //    // var formServerTransId = document.createElement("input");
  //    // formServerTransId.setAttribute("type", "hidden");
  //    // formServerTransId.setAttribute("name", "serverTransId");
  //    // formServerTransId.setAttribute("value", serverTransactionId);
  //    // form.appendChild(formServerTransId);
  //    //form.submit();
  //  }

  //  // challenge failure
  //  else {
  //   document.querySelectorAll('.hide-global-logo').forEach(e => e.remove());
  //     // TODO: proceed to failure page or display failed authentication information
  //     return false;
  //  }

  // } catch (exp) {
  //   console.log(exp);

  // }


   
    const language = this.route.snapshot.paramMap.get('language');
    if(language)
    {
      if(language === 'en' || language ==='fr')
        {
          localStorage.removeItem('lang');
          this.translationService.setLanguage(this.route.snapshot.params.language); 
          localStorage['lang']=this.route.snapshot.params.language
        }
        else {
          this.router.navigate(['/locations'])
        }
    }
    this.getLocations();

    if(this.isPopup) {
      if (window.innerWidth <= 600) {
        this.mobile = true;
  
        this.disableHeader = false;
      } else {
        this.mobile = false;
  
        this.disableHeader = true;
      }
    }

    // temporarily. we'll need to set it up on the page soon
    (window as any).updateLoaderProgress(100);
    (window as any).finishAppShell?.();

    if(this.setting.configuration.uIoptions && this.setting.configuration.homePageConfiguration != null && this.setting.configuration.uIoptions?.homePageOption == 10) {
      this.homersLayout = true;
    } else {
      this.homersLayout = false;
    }

    this.searchSubject
    .pipe(
      debounceTime(300),
      distinctUntilChanged()
    )
    .subscribe(query => {
      this.performSearch(query);
    });
    
  }

  @HostListener('window:resize', ['$event'])  
  onResize(event) { 
    if(this.isPopup) {
      if (window.innerWidth <= 600) { // follows the value of the modal
        this.mobile = true;
        this.disableHeader = false;
      } else {
        this.mobile = false;
        this.disableHeader = true;
      }
    } 
  } 

  /*
  async useGeo() {
    const loader = await this.loader.create();
    await loader.present();

    this.geolocation.getCurrentPosition({ enableHighAccuracy: false, timeout: 20000 })
      .then(position => {
        this.position = position;

        this.sortLocations();
      })
      .catch((reason) => {

        let messageKey;
        if (reason.code == 1) //PositionError.PERMISSION_DENIED)
          messageKey = 'Geolocation.PermissionDenied';
        else if (reason.code == 2) //PositionError.POSITION_UNAVAILABLE)
          messageKey = 'Geolocation.PositionUnavailable';
        else if (reason.code == 3) //PositionError.TIMEOUT)
          messageKey = 'Geolocation.Timeout';

        if (messageKey)
          this.alert.showTranslate(messageKey);
        else
          this.alert.showUnexpectedErrorMsg();
      })
      .finally(() => {
        loader.dismiss();
      });
  }
  */

  // new format for location
  async useGeo() {
    const loader = await this.loader.create();
    await loader.present();

    try {
      const position = await Geolocation.getCurrentPosition({ enableHighAccuracy: true, timeout: 5000 });

      this.hasPosition = true;

      this.position = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      } as IGeoposition;

      this.sortLocations();
    } catch (reason: any) {

      /*
      let messageKey: string | undefined;

      if (reason.code === 1) // PERMISSION_DENIED
        messageKey = 'Geolocation.PermissionDenied';
      else if (reason.code === 2) // POSITION_UNAVAILABLE
        messageKey = 'Geolocation.PositionUnavailable';
      else if (reason.code === 3) // TIMEOUT
        messageKey = 'Geolocation.Timeout';

      if (messageKey) {
        this.alert.showTranslate(messageKey);
      } else {
        this.alert.showUnexpectedErrorMsg();
      }
        */

      try {
        const position = await Geolocation.getCurrentPosition({ enableHighAccuracy: false, timeout: 5000 });

        this.hasPosition = true;

        this.position = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        } as IGeoposition;

        this.sortLocations();
      } catch (reason2: any) {
        let messageKey: string | undefined;

        if (reason2.code === 1) // PERMISSION_DENIED
          messageKey = 'Geolocation.PermissionDenied';
        else if (reason2.code === 2) // POSITION_UNAVAILABLE
          messageKey = 'Geolocation.PositionUnavailable';
        else if (reason2.code === 3) // TIMEOUT
          messageKey = 'Geolocation.Timeout';

        if (messageKey) {
          this.alert.showTranslate(messageKey);
        } else {
          this.alert.showUnexpectedErrorMsg();
        }
      }
    } finally {
      loader.dismiss();
    }
  }

  sortLocations(): void {
    // if we dont have a geo position forget it.
    if (!this.position)
      return;

    // build closer score :)
    this.locations
      .forEach((t) => {
        if (t.Longitude && t.Latitude) {
          t.__distanceInKM = GeolocationHelpers.distance(
            //this.position.coords.latitude,
            this.position.latitude,
            //this.position.coords.longitude,
            this.position.longitude,
            t.Latitude,
            t.Longitude
          );
        } else {
          t.__distanceInKM = Number.MAX_VALUE;
        }
      });

    this.locations = this.locations.sort((lhs, rhs) => lhs.__distanceInKM - rhs.__distanceInKM);

    if (!this.searchText.trim()) {
      this.displayedLocations = [...this.locations];
    }
  }

  async getLocations() {
    const loader = await this.loader.create();
    await loader.present();
    this.locationService.locations()
      .pipe(finalize(() => {
        loader.dismiss();
      }))
      .subscribe(locations => {
        this.locations = locations;

        // The displayed list initially contains all locations.
        this.displayedLocations = [...locations];

        console.log(this.locations);

        this.showGeoLocation = true;
        this.hasPosition = true;
        
        this.locations.forEach(t => {
          this.setLocationCurrentDayOpenHours(t);
        });

        this.useGeo();
      },
        res => this.alert.showUnexpectedErrorMsg()
      );
  }

  private performSearch(query: string): void {
    //const query = this.searchText.trim().toLowerCase();

    // Empty search = restore normal location ordering
    if (!query) {
      this.displayedLocations = [...this.locations];

      // Go back to user's current position
      if (this.position) {
        this.searchMapCenter = {
          latitude: this.position.latitude,
          longitude: this.position.longitude
        };
      } else {
        this.searchMapCenter = null;
      }

      return;
    }

    if (!this.locations?.length) {
      return;
    }

    const scoredLocations = this.locations.map(location => {
      const name = (location.DisplayName || '').toLowerCase();
      const address = (location.FormattedAddress || '').toLowerCase();

      let score = 0;

      // Exact store-name match
      if (name === query) {
        score += 1000;
      }

      // Store name starts with search
      if (name.startsWith(query)) {
        score += 500;
      }

      // Store name contains search
      if (name.includes(query)) {
        score += 300;
      }

      // Address starts with search
      if (address.startsWith(query)) {
        score += 200;
      }

      // Address contains search
      if (address.includes(query)) {
        score += 100;
      }

      return {
        location,
        score
      };
    });

    scoredLocations.sort((a, b) => b.score - a.score);

    this.displayedLocations = scoredLocations.map(item => item.location);

    // If we found a matching store, center on the best match.
    const bestMatch = scoredLocations.find(item => item.score > 0);

    if (bestMatch) {
      const location = bestMatch.location;

      if (location.Latitude && location.Longitude) {
        this.searchMapCenter = {
          latitude: location.Latitude,
          longitude: location.Longitude
        };
      }

      return;
    }

    // No store matched.
    // Try Google Maps geocoding the user's search.
    this.geocodeSearch(query);
  }

  private geocodeSearch(query: string): void {
    if (typeof google === 'undefined' || !google.maps) {
      return;
    }

    const geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      {
        address: query
      },
      (results: any[], status: string) => {

        if (
          status === 'OK' &&
          results &&
          results.length > 0
        ) {
          const location = results[0].geometry.location;

          this.searchMapCenter = {
            latitude: location.lat(),
            longitude: location.lng()
          };
        }
      }
    );
  }

  private setLocationCurrentDayOpenHours(location: ILocation): void {
    location.__currentDayHours = DateHelpers.getCurrentDayOpenHours(location.Hours);
  }

  closePopup(){
    if(this.isPopup) {
      this.modalCtrl.dismiss();
    }
  }
}
